export enum UserRole {
    BenefitsAnalyst = "BA",
    BusinessPartner = "BP",
    ImprestAnalyst = "IA",
    ImprestAnalystForeign = "IF",
    ImprestAnalystLocal = "IL",
    SuperUser = "U"
}
export enum UserRoleReversed {
    BA = "Benefits Analyst",
    BP = "Business Partner",
    IA = "Imprest Analyst",
    IF = "Imprest Analyst - Foreign",
    IL = "Imprest Analyst - Local",
    U = "Super User"
}